import { z } from 'zod';
import { emailSchema } from './common.js';
/**
 * Функции в разработке (ADR-017): в релизе (ветка main, прод) выключены — их нет ни в интерфейсе, ни в API.
 * Включаются переменной FEATURES (через запятую, `all` — все); в ветке develop и в тестах — все.
 */
export const FEATURES = ['tasks', 'ai', 'agent', 'billing', 'sites'];
export function parseFeatures(value) {
    const raw = (value ?? 'all')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    if (raw.includes('all'))
        return [...FEATURES];
    return FEATURES.filter((f) => raw.includes(f));
}
/** Доступ к приложению (стадия white list): новые аккаунты ждут одобрения администратора. */
export const ACCESS_STATES = ['pending', 'approved', 'rejected'];
export const accessListQuerySchema = z.object({
    status: z.enum(ACCESS_STATES).default('pending'),
});
export const accessDecisionSchema = z.object({
    decision: z.enum(['approve', 'reject']),
});
export const allowlistAddSchema = z.object({
    email: emailSchema,
});
//# sourceMappingURL=admin.js.map